const values = {
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL?.trim(),
  supabasePublishableKey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY?.trim(),
  appUrl: import.meta.env.VITE_APP_URL?.trim() || window.location.origin,
  previewPasswordLogin: import.meta.env.VITE_PREVIEW_PASSWORD_LOGIN === "true",
};

export const env = Object.freeze({
  ...values,
  isSupabaseConfigured: Boolean(values.supabaseUrl && values.supabasePublishableKey),
});

export function requireSupabaseConfig() {
  if (!env.isSupabaseConfigured) {
    throw new Error(
      "Matchbase is not connected to Supabase. Set VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY.",
    );
  }
  return env;
}
